import { useNavigate } from "react-router-dom";
import AppButton from "../components/AppButton";
import { ROUTES } from "./config";

function PageNotFound() {
    const navigate = useNavigate();

    return (
        <div className="mt-10 text-2xl text-red-error w-full h-full grid gap-4 place-content-center">
            <span>Page not found</span>
            <AppButton onClick={() => navigate(`/${ROUTES.OPEN_TEST.path}`)}>
                Go to open test
            </AppButton>
        </div>
    );
}

export default PageNotFound;
